import { render } from "./PromotionManagement.vue?vue&type=template&id=2c97ac41&scoped=true"
import script from "./PromotionManagement.vue?vue&type=script&lang=js"
export * from "./PromotionManagement.vue?vue&type=script&lang=js"

import "./PromotionManagement.vue?vue&type=style&index=0&id=2c97ac41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c97ac41"]])

export default __exports__